<section class="contact-hero" aria-labelledby="contact-title">
  <div class="hero-content">
    <p class="eyebrow">Customer Care</p>
    <h1 id="contact-title">Let's keep your fit moving.</h1>
    <p>
      Have a question about an order, sizing, shipping, or a future
      collaboration? Reach out and the {{appname}} team will help you find the
      next best step.
    </p>
    <div class="hero-actions" aria-label="Primary contact actions">
      <a class="primary-action" href="mailto:{{email}}" aria-label="Email {{appname}}" target="_blank">
        <mat-icon fontIcon="mail"></mat-icon>
        <span>Email support</span>
      </a>
      <a class="secondary-action" href="{{facebook}}" target="_blank" rel="noopener noreferrer"
        aria-label="Follow {{appname}} on Facebook">
        <img src="/images/icons/facebook.webp" width="22" height="22" alt="" />
        <span>Follow @veyorafit</span>
      </a>
    </div>
  </div>
</section>

<main class="contact-main">
  <section class="contact-overview" aria-labelledby="support-heading">
    <div class="section-heading">
      <p class="eyebrow">How We Help</p>
      <h2 id="support-heading">Clear answers, from checkout to closet.</h2>
    </div>
    <div class="response-panel">
      <div>
        <mat-icon fontIcon="support_agent"></mat-icon>
        <span>Order support</span>
      </div>
      <div>
        <mat-icon fontIcon="local_shipping"></mat-icon>
        <span>Shipping questions</span>
      </div>
      <div>
        <mat-icon fontIcon="keyboard_return"></mat-icon>
        <span>Returns and exchanges</span>
      </div>
    </div>
  </section>

  <section class="contact-grid" aria-label="Contact options">
    <article class="contact-card featured">
      <div class="icon-badge">
        <mat-icon fontIcon="alternate_email"></mat-icon>
      </div>
      <div>
        <p class="card-kicker">Fastest Route</p>
        <h3>Email Us</h3>
        <a href="mailto:{{email}}">{{email}}</a>
        <p>
          Best for order inquiries, shipping updates, returns, exchanges, and
          general support.
        </p>
      </div>
    </article>

    <article class="contact-card">
      <div class="icon-badge image-badge">
        <img src="/images/icons/facebook.webp" width="26" height="26" alt="" />
      </div>
      <div>
        <p class="card-kicker">Community</p>
        <h3>Follow Us on Facebook</h3>
        <a href="{{facebook}}" target="_blank" rel="noopener noreferrer">@veyorafit</a>
        <p>
          Stay connected for new arrivals, workout inspiration, and everyday
          moments from {{appname}}.
        </p>
      </div>
    </article>

    <article class="contact-card address-card">
      <div class="icon-badge">
        <mat-icon fontIcon="location_on"></mat-icon>
      </div>
      <div>
        <p class="card-kicker">Correspondence</p>
        <h3>Mailing Address</h3>
        <address>
          {{address1}}<br />
          {{address2}}
        </address>
        <p class="note">
          This address is for mailing correspondence only. For customer
          support, please contact us by email.
        </p>
      </div>
    </article>

    <article class="contact-card events-card">
      <div class="icon-badge">
        <mat-icon fontIcon="event_available"></mat-icon>
      </div>
      <div>
        <p class="card-kicker">In Person</p>
        <h3>Trade Shows</h3>
        <strong>Coming Soon</strong>
        <p>
          {{appname}} looks forward to meeting our community, partners, and
          customers at future trade shows and events.
        </p>
      </div>
    </article>
  </section>

  <section class="support-note" aria-label="Support reminder">
    <mat-icon fontIcon="mark_email_unread"></mat-icon>
    <p>
      Include your order number when you email us so we can find the right
      details quickly.
    </p>
  </section>
</main>